const ConnectArrowIcon = ({ ...props }) => {
  return (
    <svg width='28' height='28' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g clipPath='url(#clip0_669_1196)'>
        <circle cx='14' cy='14' r='14' />
        <path d='M19.3536 14.3536C19.5488 14.1583 19.5488 13.8417 19.3536 13.6464L16.1716 10.4645C15.9763 10.2692 15.6597 10.2692 15.4645 10.4645C15.2692 10.6597 15.2692 10.9763 15.4645 11.1716L18.2929 14L15.4645 16.8284C15.2692 17.0237 15.2692 17.3403 15.4645 17.5355C15.6597 17.7308 15.9763 17.7308 16.1716 17.5355L19.3536 14.3536ZM10 14.5H19V13.5H10V14.5Z' />
      </g>
    </svg>
  );
};

export default ConnectArrowIcon;
